var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('sidebar-menu',{class:_vm.menuClass,style:(`--home-new-text:'${_vm.newRibbonLabel}'`),attrs:{"menu":_vm.menu,"width":"100%","widthCollapsed":"0","collapsed":_vm.isSidebarCollapsed,"disableHover":true},on:{"toggle-collapse":_vm.toggleSidebar,"item-click":_vm.onItemClick}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }